import React, { useRef, useEffect, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import UserSelectors from 'Stores/User/Selectors'
import AuthSelectors from 'Stores/Auth/Selectors'
import UserActions from 'Stores/User/Actions'
import TextField from '@mui/material/TextField'
import {
  IFFilter,
  IFButton,
  IFText,
  IFAvatar,
  IFDialog,
  IFSkeleton,
  IFModal,
  FilterNoMatch,
  IFsvg,
  IFToggle,
} from 'Components'
import {
  UserList,
  UserListHeader,
  TransactionList,
  PaymentSessionList,
  UserPageTabs,
  PointsList,
  PaymentCardList,
  UserChargingTokenList,
  AdminActionList,
  OngoingSessionList,
  UserNotificationList,
} from 'Containers'
import Colors from 'Theme/Colors'
import Styles from './UserPage.module.css'
import Edit from '@mui/icons-material/Edit'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import RequestState from 'Enums/RequestState'
import { Scrollbars } from 'react-custom-scrollbars'
import InfinityEnums from 'Enums/InfinityEnums'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/system'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { Menu, MenuItem, Select, Tooltip } from '@mui/material'
import { Divider } from 'rsuite'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'
import styled from 'styled-components'
import history from 'history/browser'
import { useLocation } from 'react-router-dom'
import LoadingBar from 'react-top-loading-bar'
import ReactFlagsSelect from 'react-flags-select'
import { encodeObjectToBase64 } from 'Utils/Base64Functions'
const Countries = require('world-countries/countries.json')
import { parsePhoneNumber } from 'awesome-phonenumber'
import { useNavigate } from 'react-router-dom'
import { Actions, Subjects } from 'Enums/permissionKeys'
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined'
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined'

const StyledPhoneInput = styled(PhoneInput)`
  & .form-control {
    font-family: ProximaNova !important;
    height: 45px;
    font-size: 14px !important;
    color: ${Colors.text} !important;

    &:hover {
      border-color: ${Colors.primary} !important;
    }

    &:focus {
      border-color: ${Colors.primary} !important;
      box-shadow: 0 0 0 1px ${Colors.primary} !important;
    }
  }

  & .country-list {
    width: 10rem !important;
    margin: 0 !important;
    border-radius: 5px !important;
    font-size: 14px !important;
    font-family: ProximaNova !important;
  }
  & .special-label {
    font-size: 14px !important;
    color: ${Colors.primary} !important;
    font-family: ProximaNova !important;
  }
`
const UserPage = ({
  admin,
  editingAdminRole,
  user,
  transactionsFilter,
  paymentsFilter,
  usersFilter,
  adjustWallet,
  toggleUserIsActive,
  userDetailsRequestState,
  fetchUserList,
  fetchUserTransactionList,
  clearUsers,
  setUsersFilter,
  fetchUserListRequestState,
  fetchUserDetails,
  clearTransactions,
  setUserTransactionsFilter,
  clearUserTransactionsFilter,
  selectedUserId,
  clearCurrentUser,
  setCurrentUserNewPhone,
  fetchUserPaymentSessionList,
  setUserPaymentsFilter,
  clearUserPaymentsFilter,
  clearPaymentSessions,
  usersCount,
  setUserListSelectedIndex,
  selectedUserIndex,
  userList,
  fetchUserTransactionListRequestState,
  fetchPaymentSessionListRequestState,
  setSelectedCountry,
  fetchUserListCountRequestState,
  fetchAdminActionsUsersList,
  adminActions,
  adminActionsPaginationOffset,
  fetchAdminActionsRequestState,
  adminActionsFilters,
  setAdminActionsFilter,
  clearAdminActions,
  clearAdminActionsFilter,
  setAdminActionsPaginationOffset,
  setUserTransactionsPaginationOffset,
  setUserPaymentsPaginationOffset,
  paymentSessionListPaginationOffset,
  transactionListPaginationOffset,
  fetchOngoingSessionsListRequestState,
  fetchOngoingSessionsList,
  setCurrentUserEmail,
  setCurrentUserEmailRequestState,
  resendEmailVerification,
  resendEmailVerificationRequestState,
  fetchUserNotificationList,
  notificationsFilters,
  fetchUserNotificationListRequestState,
  setUserNotificationsFilter,
  clearNotifications,
  clearUserNotificationsFilter,
  setUserNotificationsPaginationOffset,
}) => {
  const navigate = useNavigate()
  useEffect(() => {
    const handlePopState = () => {
      const parts = history.location.pathname.split('/')
      const id = parts[parts.length - 1]
      if (typeof id === 'string' && /^[a-fA-F0-9]{24}$/.test(id)) {
        const index = userList.findIndex((user) => user.id === id)
        if (selectedUserIndex !== -1 && index !== selectedUserIndex) {
          if (index !== -1) {
            setUserListSelectedIndex(index)
          }
        }
      }
    }
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [selectedUserIndex])
  const tabTitles = {
    Transactions: 'Transactions',
    ...(editingAdminRole?.can(
      Actions.VIEW_ONGOING_SESSIONS,
      Subjects.USERS,
    ) && {
      OngoingSessions: 'Live Charging',
    }),
    PaymentSessions: 'Payment Sessions',
    ...(editingAdminRole?.can(Actions.VIEW_NOTIFICATIONS, Subjects.USERS) && {
      Notifications: 'Notifications',
    }),
    ...(editingAdminRole?.can(Actions.VIEW, Subjects.ADMIN_ACTIONS) && {
      AdminActions: 'Admin Actions',
    }),
  }

  const tabTitlesCards = {
    ChargingTokens: 'Charging Tokens',
    ...(editingAdminRole?.can(Actions.VIEW_PAYMENT_CARDS, Subjects.USERS) && {
      PaymentCards: 'Payment Cards',
    }),
  }
  const userPageTabsRef = useRef()
  const userPageTabsCardRef = useRef()
  const [selectedDetails, setSelectedDetails] = useState(0)
  const [selectedDetailsCards, setSelectedDetailsCards] = useState(0)
  // Tabs are conditionally present based on permissions, so the numeric index is
  // not stable. Derive the active tab key and switch on that instead.
  const selectedTabKey = Object.keys(tabTitles)[selectedDetails]
  const { t } = useTranslation()
  const userFilterRef = useRef(null)
  const transactionsFilterRef = useRef(null)
  const paymentsFilterRef = useRef(null)
  const showDialogHandler = useRef(null)
  const showDialogHandlerPhone = useRef(null)
  const showDialogHandlerPoints = useRef(null)
  const showDialogHandlerWallet = useRef(null)
  const showDialogHandlerEmail = useRef(null)
  const emailVerifiedToggleRef = useRef(null)
  const notificationsFilterRef = useRef(null)
  const [editPhoneVisible, setEditPhoneVisible] = React.useState(false)
  const [editEmailVisible, setEditEmailVisible] = React.useState(false)
  const [newUserEmail, setNewUserEmail] = useState('')
  const [sign, setSign] = useState(t('UserPage.AdjustAmountButtonTextAdd'))
  const [amount, setAmount] = useState()
  const [isDead, setisDead] = React.useState(true)
  const [tablesHeight, setTablesHeight] = React.useState(0)
  const tablesRef = useRef(null)
  const [allowedCountries, setAllowedCountries] = useState()
  const [allowedCountryPhones, setAllowedCountryPhones] = useState()
  const [allowedCountryPhonesObj, setAllowedCountryPhonesObj] = useState()

  useEffect(() => {
    if (user.groupedBillingAccounts) {
      const allowedC = user.groupedBillingAccounts
        ?.map((wallet) => wallet?.code?.toLowerCase())
        .filter(Boolean)
      setAllowedCountries(allowedC)
      const matchingCountries = Countries.filter((country) =>
        allowedC?.includes(country.cca2.toLowerCase()),
      )
      const allowedCPhones = matchingCountries?.map(
        (country) => country.idd.root + country.idd.suffixes[0],
      )
      setAllowedCountryPhones(allowedCPhones)
      const allowedCPhonesObj = matchingCountries?.reduce((acc, country) => {
        if (country.cca2 && country.idd) {
          acc[country.cca2.toLowerCase()] =
            country.idd.root + country.idd.suffixes[0]
        }
        return acc
      }, {})
      setAllowedCountryPhonesObj(allowedCPhonesObj)
    }
  }, [user.groupedBillingAccounts])

  useEffect(() => {
    if (allowedCountries) {
      if (user.country?.codeTwoLetters) {
        if (
          allowedCountries?.some(
            (countryCode) =>
              countryCode === user.country?.codeTwoLetters.toLowerCase(),
          )
        ) {
          setNewUserPhone(
            allowedCountryPhonesObj[user.country.codeTwoLetters.toLowerCase()],
          )
          setCountry(user.country.codeTwoLetters.toLowerCase())
        } else {
          if (allowedCountries) {
            setNewUserPhone(allowedCountryPhones[0])
            setCountry(allowedCountries[0])
          }
        }
      }
    }
  }, [allowedCountries])
  const [newUserPhone, setNewUserPhone] = useState()
  const [country, setCountry] = useState()

  const userListRef = useRef(null)
  const scrollUserList = (index) => {
    userListRef?.current?.scrollToIndex({
      index: index,
      behavior: 'smooth',
      align: 'start',
    })
  }
  const divRef = useRef(null)
  const handleScrollToTop = () => {
    if (divRef.current) {
      divRef.current.scrollTop()
    }
  }

  const [progress, setProgress] = useState(0)
  const [isFirstLoaded, setIsFirstLoaded] = useState(true)
  const [error, setError] = useState(false)
  const [
    fetchTransactionListLoadingState,
    setFetchTransactionListLoadingState,
  ] = useState(true)
  const [
    fetchTransactionListFirstFetched,
    setFetchTransactionListFirstFetched,
  ] = useState(true)

  const [fetchPaymentListLoadingState, setFetchPaymentListLoadingState] =
    useState(true)
  const [
    fetchAdminActionsListLoadingState,
    setFetchAdminActionsListLoadingState,
  ] = useState(true)
  const [refreshingLogs, setRefreshingLogs] = useState(false)
  const [transactionListKey, setTransactionListKey] = useState(0)
  const [transactionListLastUpdated, setTransactionListLastUpdated] =
    useState(null)
  const [paymentListLastUpdated, setPaymentListLastUpdated] = useState(null)
  const [adminActionListLastUpdated, setAdminActionListLastUpdated] =
    useState(null)
  const [ongoingSessionsListLastUpdated, setOngoingSessionsListLastUpdated] =
    useState(null)
  const [notificationListLastUpdated, setNotificationListLastUpdated] =
    useState(null)

  useEffect(() => {
    if (fetchUserTransactionListRequestState === RequestState.SUCCEEDED) {
      setFetchTransactionListFirstFetched(false)
      setFetchTransactionListLoadingState(false)
    }
  }, [fetchUserTransactionListRequestState])
  useEffect(() => {
    if (fetchPaymentSessionListRequestState === RequestState.SUCCEEDED)
      setFetchPaymentListLoadingState(false)
  }, [fetchPaymentSessionListRequestState])

  useEffect(() => {
    if (fetchAdminActionsRequestState === RequestState.SUCCEEDED)
      setFetchAdminActionsListLoadingState(false)
  }, [fetchAdminActionsRequestState])
  useEffect(() => {
    if (isFirstLoaded) {
      if (fetchUserListRequestState === RequestState.LOADING && progress === 0)
        setProgress(progress + 10)

      if (fetchUserListRequestState === RequestState.SUCCEEDED)
        if (userList.length === 0) {
          setProgress(100)
        } else {
          setProgress(progress + 40)
        }
      if (
        fetchUserListRequestState !== RequestState.LOADING &&
        fetchUserListRequestState !== RequestState.UNINITIALIZED &&
        fetchUserListRequestState !== RequestState.SUCCEEDED
      )
        setProgress(100)
    }
  }, [fetchUserListRequestState, isFirstLoaded])

  useEffect(() => {
    if (isFirstLoaded) {
      if (
        fetchUserTransactionListRequestState === RequestState.LOADING &&
        progress === 0
      )
        setProgress(progress + 10)
      if (fetchUserTransactionListRequestState === RequestState.SUCCEEDED) {
        setProgress(100)
        setIsFirstLoaded(false)
      }
      if (
        fetchUserTransactionListRequestState !== RequestState.LOADING &&
        fetchUserTransactionListRequestState !== RequestState.UNINITIALIZED &&
        fetchUserTransactionListRequestState !== RequestState.SUCCEEDED
      )
        setProgress(100)
    }
  }, [fetchUserTransactionListRequestState, isFirstLoaded])
  useEffect(() => {
    setError(false)
    return () => {
      setError(false)
      clearUsers()
      clearPaymentSessions()
      clearTransactions()
      clearCurrentUser()
      userFilterRef?.current?.clearFilter()
      setIsFirstLoaded(true)
    }
  }, [])
  useEffect(() => {
    if (
      fetchUserTransactionListRequestState !== RequestState.LOADING &&
      fetchUserTransactionListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setTransactionListLastUpdated(Date.now())
    }
  }, [fetchUserTransactionListRequestState])
  useEffect(() => {
    if (
      fetchPaymentSessionListRequestState !== RequestState.LOADING &&
      fetchPaymentSessionListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setPaymentListLastUpdated(Date.now())
    }
  }, [fetchPaymentSessionListRequestState])
  useEffect(() => {
    if (
      fetchAdminActionsRequestState !== RequestState.LOADING &&
      fetchAdminActionsRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setAdminActionListLastUpdated(Date.now())
    }
  }, [fetchAdminActionsRequestState])

  useEffect(() => {
    if (
      fetchOngoingSessionsListRequestState !== RequestState.LOADING &&
      fetchOngoingSessionsListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setOngoingSessionsListLastUpdated(Date.now())
    }
  }, [fetchOngoingSessionsListRequestState])

  useEffect(() => {
    if (
      fetchUserNotificationListRequestState !== RequestState.LOADING &&
      fetchUserNotificationListRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingLogs(false)
      setNotificationListLastUpdated(Date.now())
    }
  }, [fetchUserNotificationListRequestState])

  useEffect(() => {
    if (user.changePhoneRequestState == RequestState.SUCCEEDED)
      showDialogHandlerPhone.current.dismiss()
  }, [user.changePhoneRequestState])

  useEffect(() => {
    if (
      setCurrentUserEmailRequestState === RequestState.SUCCEEDED &&
      showDialogHandlerEmail.current
    )
      showDialogHandlerEmail.current.dismiss()
  }, [setCurrentUserEmailRequestState])
  const handleUserFilter = (newFilter) => {
    clearCurrentUser()
    clearUsers()
    setUserListSelectedIndex(-1)
    clearTransactions()
    setError(false)
    history.push({
      pathname: '/user',
      search: `?filter=${encodeObjectToBase64(newFilter)}`,
    })
    setUsersFilter(newFilter)
    fetchUserList(
      0,
      () => {},
      () => navigate('/NotFound'),
    )
  }

  let location = useLocation()
  useEffect(() => {
    if (location.pathname === '/user' || location.pathname === '/user/') {
      clearUsers()
      clearCurrentUser()
      setError(false)
      userFilterRef?.current?.clearFilter()
    }
  }, [location])
  useEffect(() => {
    if (selectedUserId) {
      handleScrollToTop()
      clearCurrentUser()
      clearTransactions()
      setFetchTransactionListFirstFetched(true)
      setFetchTransactionListLoadingState(true)
      setFetchPaymentListLoadingState(true)
      setFetchAdminActionsListLoadingState(true)
      fetchUserDetails(selectedUserId, () => navigate('/NotFound'))
      setIsFirstLoaded(true)
      setError(false)
      clearUserTransactionsFilter(admin)
      clearUserPaymentsFilter(admin)
    }

    if (userPageTabsRef.current) {
      userPageTabsRef.current.resetIndex()
      setSelectedDetails(0)
    }
    if (userPageTabsCardRef.current) {
      userPageTabsCardRef.current.resetIndex()
      setSelectedDetailsCards(0)
    }
  }, [selectedUserId])
  useEffect(() => {
    if (selectedUserId && selectedTabKey === 'Transactions') {
      fetchUserTransactionList(selectedUserId, transactionsFilter, 0)
    }
  }, [transactionsFilter, selectedUserId, selectedTabKey])
  useEffect(() => {
    if (selectedUserId && selectedTabKey === 'PaymentSessions') {
      fetchUserPaymentSessionList(selectedUserId, paymentsFilter, 0)
    }
  }, [paymentsFilter, selectedUserId, selectedTabKey])

  useEffect(() => {
    if (selectedUserId && selectedTabKey === 'AdminActions') {
      fetchAdminActionsUsersList(selectedUserId, adminActionsFilters, 0)
    }
  }, [adminActionsFilters, selectedUserId, selectedTabKey])

  useEffect(() => {
    if (selectedUserId && selectedTabKey === 'Notifications') {
      fetchUserNotificationList(selectedUserId, notificationsFilters, 0)
    }
  }, [notificationsFilters, selectedUserId, selectedTabKey])

  useEffect(() => {
    fetchUserList(
      0,
      (e) => {
        if (e) {
          setError(true)
          setProgress(100)
        } else {
          setError(false)
        }
      },
      () => navigate('/NotFound'),
    )
    setIsFirstLoaded(true)
  }, [clearUsers])

  const handleOnChange = (value, countryObj, e, formattedValue) => {
    if (country === countryObj?.countryCode) {
      const { valid, type } = parsePhoneNumber(formattedValue, {
        regionCode: countryObj.countryCode.toUpperCase(),
      })
      setNewUserPhone(formattedValue)
      const isNotDead = valid && type === 'mobile'
      setisDead(!isNotDead)
    } else {
      setNewUserPhone(countryObj?.dialCode)
      setCountry(countryObj?.countryCode)
      setisDead(true)
    }
  }

  const handleSelectedTab = (index) => {
    setSelectedDetails(index)
  }
  const handleSelectedTabCard = (index) => {
    setSelectedDetailsCards(index)
  }
  const [anchor, setAnchor] = useState(null)

  const menuClickHandler = (event) => {
    setAnchor(event.currentTarget)
  }

  const menuCloseHandler = () => setAnchor(null)
  const deactivateHandler = () => {
    setAnchor(null)
    showDialogHandler.current.show()
  }
  useEffect(() => {
    const handleResize = (entries) => {
      if (entries[0]) {
        const { height } = entries[0].contentRect
        setTablesHeight(height)
      }
    }

    const resizeObserver = new ResizeObserver(handleResize)
    if (tablesRef.current) {
      resizeObserver.observe(tablesRef.current)
    }

    return () => {
      if (tablesRef.current) {
        resizeObserver.unobserve(tablesRef.current)
      }
    }
  }, [])
  const [selected, setSelected] = useState()
  const [wallet, setWallet] = useState()
  useEffect(() => {
    if (user.country?.codeTwoLetters) {
      if (
        user.groupedBillingAccounts?.some(
          (wallet) => wallet.code === user.country?.codeTwoLetters,
        )
      ) {
        setSelected(user.country?.codeTwoLetters)
      } else {
        if (user?.groupedBillingAccounts)
          setSelected(user?.groupedBillingAccounts[0]?.code)
      }
    }
  }, [user.country])

  useEffect(() => {
    setWallet(
      user?.groupedBillingAccounts?.find((item) => item.code === selected),
    )
  }, [selected, user])
  useEffect(() => {
    if (user?.groupedBillingAccounts?.length > 1) setSelectedCountry(selected)
  }, [selected])
  const adminActionsFilterRef = useRef(null)
  useEffect(() => {
    if (selectedTabKey === 'Transactions') {
      setFetchTransactionListLoadingState(true)
      transactionsFilterRef?.current?.clearFilter()
      clearTransactions()
      clearUserTransactionsFilter(admin)
    }
    if (selectedTabKey === 'PaymentSessions') {
      setFetchPaymentListLoadingState(true)
      paymentsFilterRef?.current.clearFilter()
      clearPaymentSessions()
      clearUserPaymentsFilter(admin)
    }
    if (selectedTabKey === 'AdminActions') {
      setFetchAdminActionsListLoadingState(true)
      adminActionsFilterRef?.current?.clearFilter()
      clearAdminActions()
      clearAdminActionsFilter()
    }
    if (selectedTabKey === 'Notifications') {
      notificationsFilterRef?.current?.clearFilter()
      clearNotifications()
      clearUserNotificationsFilter(admin)
    }
  }, [selectedTabKey])
  const flattenedActions = useMemo(() => {
    return adminActions
      .map((action) => {
        return action.targets.map((target) => {
          let userAction
          let subject
          let country
          let model = ''
          let phrase = ''
          let verb = ''
          let createdAt = moment(action.createdAt).format('MMM DD, YYYY LTS')
          let attributes = ''

          if (admin.id === action.adminUser._id) {
            userAction = t('AdminActions.EditingAdmin')
          } else {
            userAction = action.adminUser.name
          }

          subject = `${target.reference}`

          if (target.id?.country && admin.registeredCountries.length > 1) {
            country = target.id.country
          }

          if (
            target.model === InfinityEnums.Models.User ||
            target.model === InfinityEnums.Models.BillingAccount
          ) {
            model = ''
          } else {
            model = `${target.model}:`
          }

          if (action.action === InfinityEnums.AdminActions.Edit) {
            verb = t('AdminActions.Changed')

            subject = `${target.reference}'s`

            const fields = target.attributes || []
            const formattedFields = fields
              .map((field) => {
                if (Array.isArray(field.newValue) || field.newValue === '') {
                  return field.name
                }
                if (typeof field.newValue === 'number') {
                  field.newValue = field.newValue.toFixed(2)
                }
                if (field.deletedValueReference) {
                  verb = t('AdminActions.Removed')
                  phrase = `${userAction} ${verb} ${
                    field.deletedValueReference
                  } ${t('AdminActions.from')} ${subject} ${field.name}`
                  return null
                }
                if (
                  typeof field.newValue === 'string' &&
                  /^[a-fA-F0-9]{24}$/.test(field.newValue)
                ) {
                  const association = action.associations.find(
                    (item) =>
                      item.id.modelId.toString() === field.newValue.toString(),
                  )
                  let newValue = association.reference
                  return `${field.name} to ${newValue}`
                }
                return `${field.name} to ${field.newValue}`
              })
              .join(', ')

            if (verb === t('AdminActions.Changed')) {
              phrase = `${userAction} ${verb} ${
                model ? model + ' ' : ''
              }${subject} ${formattedFields}`
            }

            return phrase
              ? {
                  phrase,
                  createdAt,
                  verb: action.action,
                  ...(country ? { country } : {}),
                }
              : null
          } else if (action.action === InfinityEnums.AdminActions.Create) {
            verb = t('AdminActions.Created')
            attributes = target.attributes.map((field) => {
              let newValue = field.newValue
              if (Array.isArray(newValue)) {
                newValue = newValue.map((item) => {
                  if (
                    typeof item === 'string' &&
                    /^[a-fA-F0-9]{24}$/.test(item)
                  ) {
                    const association = action.associations.find(
                      (assoc) =>
                        assoc.id.modelId.toString() === item.toString(),
                    )
                    return association ? association.reference : item
                  }
                  return item
                })
              } else if (typeof newValue === 'object' && newValue !== null) {
                newValue = Object.entries(newValue).reduce(
                  (acc, [key, value]) => {
                    if (
                      typeof value === 'string' &&
                      /^[a-fA-F0-9]{24}$/.test(value)
                    ) {
                      const association = action.associations.find(
                        (assoc) =>
                          assoc.id.modelId.toString() === value.toString(),
                      )
                      acc[key] = association ? association.reference : value
                    } else {
                      acc[key] = value
                    }
                    return acc
                  },
                  {},
                )
              } else if (
                typeof newValue === 'string' &&
                moment(newValue, moment.ISO_8601, true).isValid()
              ) {
                newValue = moment(newValue).format('MMM DD, YYYY LTS')
              } else if (
                newValue &&
                typeof newValue === 'string' &&
                /^[a-fA-F0-9]{24}$/.test(field.newValue) &&
                action.associations
              ) {
                const association = action.associations.find(
                  (item) =>
                    item.id.modelId.toString() === field.newValue.toString(),
                )
                if (association) {
                  newValue = association.reference
                }
              }

              return {
                name: field.name,
                newValue: newValue,
              }
            })
          } else if (action.action === InfinityEnums.AdminActions.Delete) {
            verb = t('AdminActions.Deleted')
          } else if (action.action === InfinityEnums.AdminActions.Deactivate) {
            verb = t('AdminActions.Deactivated')
          } else if (action.action === InfinityEnums.AdminActions.Activate) {
            verb = t('AdminActions.Activated')
          }

          phrase = `${userAction} ${verb} ${model ? model + ' ' : ''}${subject}`
          return phrase
            ? {
                phrase,
                createdAt,
                verb: action.action,
                ...(country ? { country } : {}),
                ...(action.action === InfinityEnums.AdminActions.Create
                  ? { attributes }
                  : {}),
              }
            : null
        })
      })
      .flat()
      .filter(Boolean)
  }, [user, adminActions, admin])
  const [failedRequest, setFailedRequest] = useState(false)
  useEffect(() => {
    if (
      fetchAdminActionsRequestState === RequestState.ERROR_0_NETWORK ||
      fetchAdminActionsRequestState === RequestState.ERROR_400_OCCURRED ||
      fetchAdminActionsRequestState === RequestState.ERROR_401_OCCURRED ||
      fetchAdminActionsRequestState === RequestState.ERROR_403_OCCURRED ||
      fetchAdminActionsRequestState === RequestState.ERROR_409_OCCURRED ||
      fetchAdminActionsRequestState === RequestState.ERROR_UNKNOWN_OCCURRED
    )
      setFailedRequest(true)
    if (fetchAdminActionsRequestState === RequestState.SUCCEEDED)
      setFailedRequest(false)
  }, [fetchAdminActionsRequestState])
  const loadMoreDataAdminActions = () => {
    if (
      fetchAdminActionsRequestState === RequestState.LOADING ||
      adminActionsPaginationOffset == null
    )
      return
    fetchAdminActionsUsersList(
      selectedUserId,
      adminActionsFilters,
      adminActionsPaginationOffset,
      failedRequest,
    )
  }
  const handleRetryAdminActions = () => {
    fetchAdminActionsUsersList(
      selectedUserId,
      adminActionsFilters,
      adminActionsPaginationOffset,
    )
  }
  const handleEditEmail = () => {
    setNewUserEmail(user?.email || '')
  }
  const handleEditPhone = () => {
    if (allowedCountries) {
      if (user.country?.codeTwoLetters) {
        if (
          allowedCountries?.some(
            (countryCode) =>
              countryCode === user.country?.codeTwoLetters.toLowerCase(),
          )
        ) {
          setNewUserPhone(
            allowedCountryPhonesObj[user.country.codeTwoLetters.toLowerCase()],
          )
          setCountry(user.country.codeTwoLetters.toLowerCase())
        } else {
          if (allowedCountries) {
            setNewUserPhone(allowedCountryPhones[0])
            setCountry(allowedCountries[0])
          }
        }
      }
    }
  }

  return (
    <div className={Styles.Container}>
      <div>
        <LoadingBar
          color={Colors.primary}
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
      </div>
      <div className={Styles.Filter}>
        <IFFilter
          ref={userFilterRef}
          onFilterChange={(newFilter) => {
            handleUserFilter(newFilter)
          }}
          filters={usersFilter}
          textFieldPlaceholder={t('UserPage.UsersFilterPlaceholder')}
        />
      </div>
      {(fetchUserListRequestState === RequestState.SUCCEEDED &&
        fetchUserListCountRequestState === RequestState.SUCCEEDED &&
        usersCount === 0) ||
      error ? (
        <FilterNoMatch
          title={t('UserPage.EmptyUsers')}
          subtitle={t('UserPage.filterNoUsers')}
        />
      ) : (
        <div className={Styles.UsersWrapper}>
          <div className={Styles.UsersContainer}>
            <div className={Styles.UsersList}>
              <div
                className={Styles.ListWrapper}
                style={{ borderColor: Colors.UserPageBackgroundContainer }}
              >
                <div>
                  <UserListHeader />
                </div>
                <div className={Styles.List}>
                  <UserList reference={userListRef} />
                </div>
              </div>
            </div>

            <div
              style={{
                backgroundColor: Colors.UserPageBackground,
                borderColor: Colors.UserPageBackgroundContainer,
              }}
              className={Styles.UserContainer}
            >
              <div className={Styles.UserDataContainer}>
                <div
                  className={Styles.UserContainerDiv}
                  style={{
                    backgroundColor: Colors.white,
                  }}
                >
                  <div className={Styles.UserAvatarContainer}>
                    <div
                      className={Styles.AvatarContainer}
                      onClick={() => {
                        scrollUserList(selectedUserIndex)
                      }}
                    >
                      {fetchUserListRequestState === RequestState.LOADING ||
                      userDetailsRequestState === RequestState.LOADING ||
                      selectedUserIndex === -1 ? (
                        <IFSkeleton
                          variant="circular"
                          width="64px"
                          height="64px"
                        />
                      ) : (
                        <>
                          <IFAvatar name={user.name} size={64} />
                          <div
                            className={Styles.StatusContainer}
                            style={{
                              backgroundColor: user?.isActive
                                ? Colors.UserActive
                                : Colors.UserBlocked,

                              borderColor: Colors.white,
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div className={Styles.NameContainer}>
                      <div className={Styles.NameDiv}>
                        <div
                          onClick={() => {
                            scrollUserList(selectedUserIndex)
                          }}
                        >
                          <IFText
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1
                            }
                            skeletonWidth="8rem"
                            skeletonHeight="1.75rem"
                            className={Styles.UserName}
                            style={{
                              color: Colors.UserPageTextColor,
                            }}
                          >
                            {user.name}
                          </IFText>
                        </div>
                        {editingAdminRole?.can(
                          Actions.TOGGLE_ACTIVATION,
                          Subjects.USERS,
                        ) &&
                          (fetchUserListRequestState === RequestState.LOADING ||
                          userDetailsRequestState === RequestState.LOADING ||
                          selectedUserIndex === -1 ? (
                            <></>
                          ) : (
                            <MoreHorizIcon
                              className={Styles.MoreIcon}
                              onClick={menuClickHandler}
                            />
                          ))}

                        <Menu
                          id="basic-menu"
                          anchorEl={anchor}
                          keepMounted
                          open={Boolean(anchor)}
                          onClose={menuCloseHandler}
                        >
                          <MenuItem
                            onClick={deactivateHandler}
                            sx={{
                              backgroundColor: 'transparent !important',
                              cursor: 'pointer',
                              '&:hover': {
                                backgroundColor: `${Colors.HoverDeactivate} !important`,
                              },
                            }}
                          >
                            <IFText
                              style={{
                                color: user.isActive
                                  ? Colors.red
                                  : Colors.UserPagePrimary,
                              }}
                            >
                              {user.isActive
                                ? t('UserPage.DeactivateButton')
                                : t('UserPage.ActivateButton')}
                            </IFText>
                          </MenuItem>
                        </Menu>
                      </div>
                      <div className={Styles.CountryDiv}>
                        {fetchUserListRequestState === RequestState.LOADING ||
                        userDetailsRequestState === RequestState.LOADING ||
                        selectedUserIndex === -1 ? (
                          <></>
                        ) : (
                          <LocationOnIcon className={Styles.LocationIcon} />
                        )}

                        <IFText
                          className={Styles.countryName}
                          style={{
                            color: Colors.text,
                          }}
                          loadSkeleton={
                            fetchUserListRequestState ===
                              RequestState.LOADING ||
                            userDetailsRequestState === RequestState.LOADING ||
                            selectedUserIndex === -1
                          }
                          skeletonWidth="4rem"
                          skeletonHeight="1.5rem"
                        >
                          {user.country?.name}
                        </IFText>
                      </div>
                    </div>
                  </div>
                  <div className={Styles.UserInfoRightContainer}>
                    {user?.groupedBillingAccounts?.length > 1 && (
                      <div className={Styles.WalletContainerTitle}>
                        <div>
                          <IFText
                            className={Styles.WalletContainerTitleText}
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState === RequestState.LOADING
                            }
                          >
                            {t('UserPage.Wallet')}
                          </IFText>
                        </div>
                        {fetchUserListRequestState === RequestState.LOADING ||
                        userDetailsRequestState === RequestState.LOADING ||
                        selectedUserIndex === -1 ? (
                          <> </>
                        ) : (
                          <div>
                            <ReactFlagsSelect
                              countries={user?.groupedBillingAccounts
                                ?.filter((wallet) => wallet.code)
                                .map((wallet) => wallet.code)}
                              customLabels={user?.groupedBillingAccounts?.reduce(
                                (acc, wallet) => {
                                  if (wallet.code && wallet.currencyCode) {
                                    acc[wallet.code] = wallet.currencyCode
                                  }
                                  return acc
                                },
                                {},
                              )}
                              showSelectedLabel={false}
                              selectedSize={14}
                              optionsSize={14}
                              fullWidth={false}
                              selected={selected}
                              onSelect={(code) => setSelected(code)}
                              selectButtonClassName={Styles.ReactFlagsSelect}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    <div className={Styles.WalletContainer}>
                      <div className={Styles.WalletItem}>
                        <div className={Styles.PointsItemGroup}>
                          <IFText
                            className={Styles.Amount}
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1
                            }
                            skeletonWidth="3rem"
                          >
                            {wallet?.currencyCode}
                          </IFText>
                          {fetchUserListRequestState === RequestState.LOADING ||
                          userDetailsRequestState === RequestState.LOADING ||
                          selectedUserIndex === -1 ? (
                            <> </>
                          ) : (
                            editingAdminRole?.can(
                              Actions.ADJUST_BALANCE,
                              Subjects.USERS,
                            ) && (
                              <Edit
                                className={Styles.PhoneIcon}
                                fontSize={'small'}
                                onClick={() => {
                                  setAmount()
                                  setSign(
                                    t('UserPage.AdjustAmountButtonTextAdd'),
                                  )
                                  showDialogHandlerWallet.current.show()
                                }}
                                style={{
                                  color: Colors.PhoneEditIcon,
                                }}
                              />
                            )
                          )}
                        </div>
                        <div>
                          <IFText
                            className={Styles.WalletText}
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1
                            }
                            skeletonWidth="3rem"
                          >
                            {wallet?.balance.toFixed(
                              wallet?.decimalPlaces || 2,
                            )}
                          </IFText>
                        </div>
                      </div>
                      <div className={Styles.Divider} />
                      <div className={Styles.WalletItem}>
                        <div className={Styles.PointsItemGroup}>
                          <IFText
                            className={Styles.Amount}
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1
                            }
                            skeletonWidth="3rem"
                          >
                            {t('UserPage.Points')}
                          </IFText>
                          {fetchUserListRequestState === RequestState.LOADING ||
                          userDetailsRequestState === RequestState.LOADING ||
                          selectedUserIndex === -1 ? (
                            <> </>
                          ) : (
                            editingAdminRole?.can(
                              Actions.VIEW,
                              Subjects.POINTS,
                            ) && (
                              <Box
                                className={Styles.InfoDiv}
                                style={{
                                  borderColor: Colors.PhoneEditIcon,
                                }}
                                onClick={() => {
                                  showDialogHandlerPoints.current.show()
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faInfo}
                                  style={{
                                    color: Colors.PhoneEditIcon,
                                  }}
                                  className={Styles.Info}
                                />
                              </Box>
                            )
                          )}
                        </div>
                        <div>
                          <IFText
                            className={Styles.WalletText}
                            loadSkeleton={
                              fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1
                            }
                            skeletonWidth="3rem"
                          >
                            {Intl.NumberFormat('en-US', 2).format(
                              wallet?.points,
                            )}
                          </IFText>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Scrollbars
                  autoHide
                  className={Styles.ScrollParent}
                  ref={divRef}
                >
                  <div className={Styles.UserInfoContainer}>
                    <div className={Styles.AllInfoContainer}>
                      <div className={Styles.UserInfo}>
                        <div className={Styles.InfoText}>
                          {user?.email ||
                          editingAdminRole?.can(
                            Actions.EDIT_EMAIL,
                            Subjects.USERS,
                          ) ? (
                            <div
                              className={Styles.Item}
                              onMouseEnter={() => {
                                if (
                                  editingAdminRole?.can(
                                    Actions.EDIT_EMAIL,
                                    Subjects.USERS,
                                  )
                                )
                                  setEditEmailVisible(true)
                              }}
                              onMouseLeave={() => {
                                if (
                                  editingAdminRole?.can(
                                    Actions.EDIT_EMAIL,
                                    Subjects.USERS,
                                  )
                                )
                                  setEditEmailVisible(false)
                              }}
                            >
                              <div className={Styles.LabelTitle}>
                                <IFText
                                  style={{ color: Colors.gray }}
                                  loadSkeleton={
                                    fetchUserListRequestState ===
                                      RequestState.LOADING ||
                                    userDetailsRequestState ===
                                      RequestState.LOADING ||
                                    selectedUserIndex === -1
                                  }
                                  skeletonWidth="4rem"
                                  skeletonHeight="1.5rem"
                                >
                                  {t('UserPage.Email')}
                                </IFText>
                              </div>
                              <div className={Styles.LabelValue}>
                                <IFText
                                  style={{
                                    color: Colors.text,
                                  }}
                                  loadSkeleton={
                                    fetchUserListRequestState ===
                                      RequestState.LOADING ||
                                    userDetailsRequestState ===
                                      RequestState.LOADING ||
                                    selectedUserIndex === -1
                                  }
                                >
                                  {user.email || '-'}
                                </IFText>
                                {user?.email &&
                                  (user.isEmailVerified ? (
                                    <Tooltip
                                      title={t('UserPage.EmailVerified')}
                                      arrow
                                    >
                                      <CheckCircleOutlinedIcon
                                        style={{
                                          color: Colors.text,
                                        }}
                                        className={Styles.VerifiedIcon}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title={t('UserPage.EmailNotVerified')}
                                      arrow
                                    >
                                      <UnpublishedOutlinedIcon
                                        style={{
                                          color: Colors.text,
                                        }}
                                        className={Styles.VerifiedIcon}
                                      />
                                    </Tooltip>
                                  ))}
                                {fetchUserListRequestState ===
                                  RequestState.LOADING ||
                                userDetailsRequestState ===
                                  RequestState.LOADING ||
                                selectedUserIndex === -1 ? (
                                  <></>
                                ) : editEmailVisible ? (
                                  <Edit
                                    className={Styles.PhoneIcon}
                                    fontSize={'small'}
                                    onClick={() => {
                                      handleEditEmail()
                                      showDialogHandlerEmail.current.show()
                                    }}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          ) : null}
                          <div
                            className={Styles.Item}
                            onMouseEnter={() => {
                              if (
                                editingAdminRole?.can(
                                  Actions.EDIT,
                                  Subjects.USERS,
                                )
                              )
                                setEditPhoneVisible(true)
                            }}
                            onMouseLeave={() => {
                              if (
                                editingAdminRole?.can(
                                  Actions.EDIT,
                                  Subjects.USERS,
                                )
                              )
                                setEditPhoneVisible(false)
                            }}
                          >
                            <div className={Styles.LabelTitle}>
                              <IFText
                                style={{ color: Colors.gray }}
                                loadSkeleton={
                                  fetchUserListRequestState ===
                                    RequestState.LOADING ||
                                  userDetailsRequestState ===
                                    RequestState.LOADING ||
                                  selectedUserIndex === -1
                                }
                                skeletonWidth="4rem"
                                skeletonHeight="1.5rem"
                              >
                                {t('UserPage.Phone')}
                              </IFText>
                            </div>
                            <div className={Styles.LabelValue}>
                              <IFText
                                style={{
                                  color: Colors.text,
                                }}
                                loadSkeleton={
                                  fetchUserListRequestState ===
                                    RequestState.LOADING ||
                                  userDetailsRequestState ===
                                    RequestState.LOADING ||
                                  selectedUserIndex === -1
                                }
                              >
                                {user.phone}
                              </IFText>
                              {fetchUserListRequestState ===
                                RequestState.LOADING ||
                              userDetailsRequestState ===
                                RequestState.LOADING ||
                              selectedUserIndex === -1 ? (
                                <></>
                              ) : editPhoneVisible ? (
                                <Edit
                                  className={Styles.PhoneIcon}
                                  fontSize={'small'}
                                  onClick={() => {
                                    showDialogHandlerPhone.current.show()
                                    handleEditPhone()
                                    setisDead(true)
                                  }}
                                  style={{
                                    paddingLeft: '0.2em',
                                    color: Colors.PhoneEditIcon,
                                  }}
                                />
                              ) : null}
                            </div>
                          </div>
                          <div className={Styles.Item}>
                            <div className={Styles.LabelTitle}>
                              <IFText
                                style={{ color: Colors.gray }}
                                loadSkeleton={
                                  fetchUserListRequestState ===
                                    RequestState.LOADING ||
                                  userDetailsRequestState ===
                                    RequestState.LOADING ||
                                  selectedUserIndex === -1
                                }
                                skeletonWidth="4rem"
                                skeletonHeight="1.5rem"
                              >
                                {t('UserPage.JoinedOn')}
                              </IFText>
                            </div>
                            <div className={Styles.LabelValue}>
                              <IFText
                                style={{
                                  color: Colors.text,
                                }}
                                loadSkeleton={
                                  fetchUserListRequestState ===
                                    RequestState.LOADING ||
                                  userDetailsRequestState ===
                                    RequestState.LOADING ||
                                  selectedUserIndex === -1
                                }
                              >
                                {moment(user.createdAt).format(
                                  'MMM DD, YYYY LTS',
                                )}
                              </IFText>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={Styles.PaymentTabs}>
                    <UserPageTabs
                      tabTitles={tabTitlesCards}
                      ref={userPageTabsCardRef}
                      onValueChange={(index) => handleSelectedTabCard(index)}
                      isLoading={
                        userDetailsRequestState === RequestState.LOADING ||
                        fetchUserListRequestState === RequestState.LOADING ||
                        selectedUserIndex === -1
                      }
                      initialIndex={0}
                    />
                  </div>
                  <div className={Styles.ChargingTokensContainer}>
                    {selectedDetailsCards == 0 && (
                      <UserChargingTokenList userId={user.id} />
                    )}
                    {selectedDetailsCards == 1 && (
                      <PaymentCardList userId={user.id} />
                    )}
                  </div>
                  <div className={Styles.TablesContainer}>
                    <div className={Styles.TransactionsContainer}>
                      <div className={Styles.TabsContainer}>
                        <UserPageTabs
                          tabTitles={tabTitles}
                          ref={userPageTabsRef}
                          onValueChange={(index) => handleSelectedTab(index)}
                          isLoading={
                            userDetailsRequestState === RequestState.LOADING ||
                            fetchUserListRequestState ===
                              RequestState.LOADING ||
                            (fetchUserTransactionListRequestState ===
                              RequestState.LOADING &&
                              fetchTransactionListFirstFetched) ||
                            selectedUserIndex === -1
                          }
                          initialIndex={0}
                        />
                        <>
                          <div className={Styles.LiveLogs}>
                            {userDetailsRequestState === RequestState.LOADING ||
                            fetchUserListRequestState ===
                              RequestState.LOADING ||
                            (fetchUserTransactionListRequestState ===
                              RequestState.LOADING &&
                              (transactionListPaginationOffset === 0 ||
                                fetchTransactionListFirstFetched)) ||
                            (fetchPaymentSessionListRequestState ===
                              RequestState.LOADING &&
                              paymentSessionListPaginationOffset === 0) ||
                            (fetchAdminActionsRequestState ===
                              RequestState.LOADING &&
                              adminActionsPaginationOffset === 0) ||
                            selectedUserIndex === -1 ? (
                              <div>
                                <div className={Styles.RefreshIconTextSkeleton}>
                                  <div className={Styles.RefreshIconSkeleton}>
                                    <IFSkeleton
                                      width="1rem"
                                      height="1rem"
                                      variant="circular"
                                    />
                                  </div>
                                  <IFSkeleton
                                    height="1.5rem"
                                    width="3rem"
                                    className={Styles.RefreshTextSkeleton}
                                  />
                                </div>

                                <IFSkeleton
                                  height="1.25rem"
                                  className={Styles.RefreshTextDateSkeleton}
                                />
                              </div>
                            ) : (
                              <>
                                <div
                                  className={Styles.RefreshIcon}
                                  onClick={() => {
                                    if (refreshingLogs) return
                                    setRefreshingLogs(true)
                                    if (selectedTabKey === 'Transactions') {
                                      setTransactionListKey((key) => key + 1)
                                      setUserTransactionsPaginationOffset(0)
                                      fetchUserTransactionList(
                                        selectedUserId,
                                        transactionsFilter,
                                        0,
                                      )
                                    } else if (
                                      selectedTabKey === 'OngoingSessions'
                                    ) {
                                      fetchOngoingSessionsList(selectedUserId)
                                    } else if (
                                      selectedTabKey === 'PaymentSessions'
                                    ) {
                                      setUserPaymentsPaginationOffset(0)
                                      fetchUserPaymentSessionList(
                                        selectedUserId,
                                        paymentsFilter,
                                        0,
                                      )
                                    } else if (
                                      selectedTabKey === 'AdminActions'
                                    ) {
                                      setAdminActionsPaginationOffset(0)
                                      fetchAdminActionsUsersList(
                                        selectedUserId,
                                        adminActionsFilters,
                                        0,
                                      )
                                    } else if (
                                      selectedTabKey === 'Notifications'
                                    ) {
                                      setUserNotificationsPaginationOffset(0)
                                      fetchUserNotificationList(
                                        selectedUserId,
                                        notificationsFilters,
                                        0,
                                      )
                                    }
                                  }}
                                >
                                  <div className={Styles.RefreshSvg}>
                                    <IFsvg.refresh
                                      height={16}
                                      width={16}
                                      fill={Colors.black}
                                    />
                                  </div>
                                  <IFText
                                    className={Styles.RefreshText}
                                    style={{ color: Colors.black }}
                                  >
                                    {t('UserPage.LastUpdated')}
                                  </IFText>
                                </div>
                                <IFText className={Styles.RefreshTextDate}>
                                  {selectedTabKey === 'Transactions' &&
                                  transactionListLastUpdated
                                    ? moment(transactionListLastUpdated).format(
                                        'MMM DD, YYYY HH:mm:ss',
                                      )
                                    : selectedTabKey === 'OngoingSessions' &&
                                        ongoingSessionsListLastUpdated
                                      ? moment(
                                          ongoingSessionsListLastUpdated,
                                        ).format('MMM DD, YYYY HH:mm:ss')
                                      : selectedTabKey === 'PaymentSessions' &&
                                          paymentListLastUpdated
                                        ? moment(paymentListLastUpdated).format(
                                            'MMM DD, YYYY HH:mm:ss',
                                          )
                                        : selectedTabKey === 'AdminActions' &&
                                            adminActionListLastUpdated
                                          ? moment(
                                              adminActionListLastUpdated,
                                            ).format('MMM DD, YYYY HH:mm:ss')
                                          : selectedTabKey ===
                                                'Notifications' &&
                                              notificationListLastUpdated
                                            ? moment(
                                                notificationListLastUpdated,
                                              ).format('MMM DD, YYYY HH:mm:ss')
                                            : ''}
                                </IFText>
                              </>
                            )}
                          </div>
                        </>
                      </div>

                      <div>
                        {selectedTabKey === 'Transactions' && (
                          <div>
                            <IFFilter
                              ref={transactionsFilterRef}
                              isLoading={
                                userDetailsRequestState ===
                                  RequestState.LOADING ||
                                fetchUserListRequestState ===
                                  RequestState.LOADING ||
                                (fetchUserTransactionListRequestState ===
                                  RequestState.LOADING &&
                                  fetchTransactionListLoadingState) ||
                                userDetailsRequestState ===
                                  RequestState.LOADING ||
                                selectedUserIndex === -1
                              }
                              onFilterChange={(newFilter) => {
                                clearTransactions()
                                setUserTransactionsFilter(newFilter)
                              }}
                              textFieldPlaceholder={t(
                                'UserPage.TransactionsFilterPlaceholder',
                              )}
                              filters={transactionsFilter}
                              disableFutureDates={true}
                              downloadUserTransactions={editingAdminRole?.can(
                                Actions.DOWNLOAD,
                                Subjects.TRANSACTIONS,
                              )}
                            />
                          </div>
                        )}
                        {selectedTabKey === 'PaymentSessions' && (
                          <div>
                            <IFFilter
                              ref={paymentsFilterRef}
                              onFilterChange={(newFilter) => {
                                clearPaymentSessions()
                                setUserPaymentsFilter(newFilter)
                              }}
                              textFieldPlaceholder={t(
                                'UserPage.PaymentsFilterPlaceholder',
                              )}
                              filters={paymentsFilter}
                              disableFutureDates={true}
                              isLoading={
                                fetchUserListRequestState ===
                                  RequestState.LOADING ||
                                (fetchPaymentSessionListRequestState ===
                                  RequestState.LOADING &&
                                  fetchPaymentListLoadingState) ||
                                selectedUserIndex === -1
                              }
                            />
                          </div>
                        )}
                        {selectedTabKey === 'AdminActions' && (
                          <div>
                            <IFFilter
                              isLoading={
                                fetchUserListRequestState ===
                                  RequestState.LOADING ||
                                (fetchAdminActionsRequestState ===
                                  RequestState.LOADING &&
                                  fetchAdminActionsListLoadingState) ||
                                selectedUserIndex === -1
                              }
                              ref={adminActionsFilterRef}
                              onFilterChange={(newFilter) => {
                                clearAdminActions()
                                setAdminActionsFilter(newFilter)
                              }}
                              filters={adminActionsFilters}
                              textFieldPlaceholder={t(
                                'AdminProfile.AdminActionsFilterPlaceHolder',
                              )}
                              disableFutureDates={true}
                            />
                          </div>
                        )}
                        {selectedTabKey === 'Notifications' && (
                          <div>
                            <IFFilter
                              ref={notificationsFilterRef}
                              isLoading={
                                fetchUserListRequestState ===
                                  RequestState.LOADING ||
                                fetchUserNotificationListRequestState ===
                                  RequestState.LOADING ||
                                selectedUserIndex === -1
                              }
                              onFilterChange={(newFilter) => {
                                clearNotifications()
                                setUserNotificationsFilter(newFilter)
                              }}
                              textFieldPlaceholder={t(
                                'UserPage.NotificationsFilterPlaceholder',
                              )}
                              filters={notificationsFilters}
                              disableFutureDates={true}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={Styles.Tables} ref={tablesRef}>
                      {selectedTabKey === 'Transactions' && (
                        <div className={Styles.Transactions}>
                          <TransactionList
                            key={transactionListKey}
                            loadHeaders={
                              fetchTransactionListLoadingState ||
                              userDetailsRequestState === RequestState.LOADING
                            }
                            userId={user.id}
                            tablesHeight={tablesHeight - 24}
                          />
                        </div>
                      )}
                      {selectedTabKey === 'OngoingSessions' && (
                        <div className={Styles.Transactions}>
                          <OngoingSessionList
                            userId={user.id}
                            tablesHeight={tablesHeight - 24}
                          />
                        </div>
                      )}
                      {selectedTabKey === 'PaymentSessions' && (
                        <div className={Styles.PaymentSessions}>
                          <PaymentSessionList
                            loadHeaders={fetchPaymentListLoadingState}
                            userId={user.id}
                            tablesHeight={tablesHeight - 24}
                          />
                        </div>
                      )}
                      {selectedTabKey === 'AdminActions' && (
                        <div className={Styles.AdminActions}>
                          <AdminActionList
                            fetchAdminActionsRequestState={
                              fetchAdminActionsRequestState
                            }
                            paginationOffset={adminActionsPaginationOffset}
                            flattenedActions={flattenedActions}
                            tablesHeight={tablesHeight - 24}
                            loadMoreData={loadMoreDataAdminActions}
                            handleRetry={handleRetryAdminActions}
                          />
                        </div>
                      )}
                      {selectedTabKey === 'Notifications' && (
                        <div className={Styles.Transactions}>
                          <UserNotificationList
                            loadHeaders={
                              userDetailsRequestState === RequestState.LOADING
                            }
                            userId={user.id}
                            tablesHeight={tablesHeight - 24}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Scrollbars>
              </div>
            </div>
          </div>
          <IFDialog
            maxWidth={'xs'}
            fullWidth={true}
            ref={showDialogHandler}
            open={false}
            title={
              user.isActive
                ? t('UserPage.DeactivateTitle')
                : t('UserPage.ActivateTitle')
            }
            bodyText={
              user.isActive
                ? t('UserPage.DeactivateBodyText')
                : t('UserPage.ActivateBodyText')
            }
            buttonAcceptonClick={() =>
              toggleUserIsActive(user.id, user.isActive ? false : true)
            }
            buttonCancelColor={Colors.UserPageCancel}
            buttonAcceptColor={
              user.isActive
                ? Colors.UserPageDeactivateButton
                : Colors.UserPageActivateButton
            }
            buttonAcceptText={
              user.isActive
                ? t('UserPage.DeactivateConfirm')
                : t('UserPage.ActivateConfirm')
            }
          />
          <IFDialog
            ref={showDialogHandlerPhone}
            maxWidth={'sm'}
            fullWidth={true}
            open={false}
            dismissOnAccept={false}
            title={t('UserPage.EditPhoneNumberModalTitle')}
            buttonAcceptonClick={() => {
              setCurrentUserNewPhone(user.id, newUserPhone)
              setNewUserPhone(allowedCountryPhonesObj[country])
              setCountry(country)
              setisDead(true)
            }}
            buttonDeadCondition={isDead}
            buttonCancelColor={Colors.UserPagePrimary}
            buttonAcceptColor={Colors.UserPagePrimary}
            buttonAcceptText={t('UserPage.EditPhoneNumberModalAcceptText')}
            buttonClassName={Styles.ButtonPhoneEditModal}
            contentClassName={Styles.contentClassName}
            isLoading={user.changePhoneRequestState === RequestState.LOADING}
          >
            <div className={Styles.TextPhoneFiled}>
              <StyledPhoneInput
                name="phoneNumber"
                placeholder="Phone number"
                type="text"
                country={country}
                onlyCountries={allowedCountries}
                value={newUserPhone}
                countryCodeEditable={false}
                autoFormat={false}
                disableDropdown={
                  allowedCountries && allowedCountries.length === 1
                }
                onChange={(value, countryObj, e, formattedValue) => {
                  handleOnChange(value, countryObj, e, formattedValue)
                }}
              />
            </div>
          </IFDialog>
          <IFDialog
            ref={showDialogHandlerEmail}
            maxWidth={'sm'}
            fullWidth={true}
            open={false}
            dismissOnAccept={false}
            title={t('UserPage.EditEmailModalTitle')}
            buttonAcceptonClick={() => {
              const isVerified = emailVerifiedToggleRef.current
                ? emailVerifiedToggleRef.current.getValue()
                : !!user?.isEmailVerified
              setCurrentUserEmail(user.id, newUserEmail, isVerified)
            }}
            buttonDeadCondition={false}
            buttonCancelColor={Colors.UserPagePrimary}
            buttonAcceptColor={Colors.UserPagePrimary}
            buttonAcceptText={t('UserPage.EditEmailModalAcceptText')}
            contentClassName={Styles.contentClassName}
            isLoading={setCurrentUserEmailRequestState === RequestState.LOADING}
          >
            <div className={Styles.EmailEditContainer}>
              <div className={Styles.EmailFieldLabel}>
                <IFText style={{ color: Colors.gray }}>
                  {t('UserPage.EmailFieldTitle')}
                </IFText>
              </div>
              <TextField
                fullWidth
                size="small"
                type="email"
                placeholder="name@company.com"
                value={newUserEmail}
                onChange={(e) => setNewUserEmail(e.target.value)}
              />
              <div className={Styles.EmailVerifiedRow}>
                <div>
                  <IFText>{t('UserPage.EmailVerifiedToggleTitle')}</IFText>
                  <IFText style={{ color: Colors.gray, fontSize: 12 }}>
                    {t('UserPage.EmailVerifiedToggleSubtitle')}
                  </IFText>
                </div>
                <IFToggle
                  ref={emailVerifiedToggleRef}
                  defaultChecked={!!user?.isEmailVerified}
                />
              </div>
              {user?.email && !user?.isEmailVerified ? (
                <div className={Styles.ResendVerificationRow}>
                  <IFButton
                    size="sm"
                    isFill={false}
                    color={Colors.UserPagePrimary}
                    text={t('UserPage.ResendVerificationLink')}
                    isLoading={
                      resendEmailVerificationRequestState ===
                      RequestState.LOADING
                    }
                    onClick={() => resendEmailVerification(user.id)}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </IFDialog>
          <IFModal
            ref={showDialogHandlerWallet}
            title={t('UserPage.AdjustTitle')}
            dismissOnAccept={false}
            maxWidth="xs"
            dialogContentStyle={{
              maxHeight: '480px',
              minHeight: 'auto',
            }}
            fullWidth={true}
            open={false}
          >
            <div className={Styles.AdjustWallet}>
              <div className={Styles.AdjustWalletItem}>
                <div className={Styles.DetailWalletModified}>
                  <div className={Styles.LabelTitleWallet}>
                    <IFText
                      className={Styles.DetailTextWallet}
                      style={{ color: Colors.DetailPanel }}
                    >
                      {t('UserPage.AmountTitle')}
                    </IFText>
                  </div>
                  <div className={Styles.LabelValueWallet}>
                    <IFText className={Styles.DetailTextWallet}>
                      {wallet?.balance.toFixed(wallet?.decimalPlaces || 2)}{' '}
                      {wallet?.currencyCode}
                    </IFText>
                  </div>
                </div>
                <div className={Styles.DetailWallet}>
                  <div className={Styles.LabelTitleWallet}>
                    <IFText
                      className={Styles.DetailTextWallet}
                      style={{ color: Colors.DetailPanel }}
                    >
                      {t('UserPage.ActionTitle')}
                    </IFText>
                  </div>
                  <div className={Styles.LabelValueWallet}>
                    <Select
                      sx={{
                        '&.MuiInputBase-root': {
                          '&:hover': {
                            borderColor: Colors.primary,
                          },
                          '&.Mui-focused': {
                            borderColor: Colors.primary,
                          },
                        },
                        '&.MuiOutlinedInput-root': {
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: Colors.primary,
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: Colors.primary,
                          },
                        },
                      }}
                      size="small"
                      className={Styles.ActionWidth}
                      variant="outlined"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sign}
                      onChange={(event) => {
                        setSign(event.target.value)
                      }}
                    >
                      <MenuItem value={t('UserPage.AdjustAmountButtonTextAdd')}>
                        <IFText className={Styles.DetailTextWallet}>
                          {t('UserPage.AdjustAmountButtonTextAdd')}
                        </IFText>
                      </MenuItem>
                      <MenuItem
                        value={t('UserPage.AdjustAmountButtonTextSubtract')}
                      >
                        <IFText className={Styles.DetailTextWallet}>
                          {t('UserPage.AdjustAmountButtonTextSubtract')}
                        </IFText>
                      </MenuItem>
                    </Select>
                  </div>
                </div>
                <div className={Styles.DetailWallet}>
                  <div className={Styles.LabelTitleWallet}>
                    <IFText
                      className={Styles.DetailTextWallet}
                      style={{ color: Colors.DetailPanel }}
                    >
                      {t('UserPage.Amount')}
                    </IFText>
                  </div>
                  <div className={Styles.LabelValueWallet}>
                    <TextField
                      size="small"
                      sx={{
                        '& .MuiInputBase-sizeSmall': {
                          fontSize: '14px',
                          fontFamily: 'ProximaNova',
                        },
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: Colors.primary,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: Colors.primary,
                          },
                        },
                      }}
                      className={Styles.ActionWidth}
                      type="number"
                      placeholder="0.00"
                      onChange={(event) => setAmount(event.target.value)}
                    />
                  </div>
                </div>
                <Divider className={Styles.DividerWallet} />
                <div className={Styles.DetailWallet}>
                  <div className={Styles.LabelTitleWallet}>
                    <IFText
                      className={Styles.DetailTextWallet}
                      style={{ color: Colors.DetailPanel }}
                    >
                      {t('UserPage.AdjustedAmount')}
                    </IFText>
                  </div>
                  <div className={Styles.LabelValueWallet}>
                    <IFText className={Styles.DetailTextWallet}>
                      {sign === t('UserPage.AdjustAmountButtonTextAdd')
                        ? amount
                          ? (
                              parseFloat(
                                wallet?.balance.toFixed(
                                  wallet?.decimalPlaces || 2,
                                ),
                                10,
                              ) + parseFloat(amount, 10)
                            )
                              .toFixed(wallet?.decimalPlaces || 2)
                              .toLocaleString()
                          : wallet?.balance.toFixed(wallet?.decimalPlaces || 2)
                        : amount
                          ? (
                              parseFloat(
                                wallet?.balance.toFixed(
                                  wallet?.decimalPlaces || 2,
                                ),
                                10,
                              ) - parseFloat(amount, 10)
                            )
                              .toFixed(wallet?.decimalPlaces || 2)
                              .toLocaleString()
                          : wallet?.balance.toFixed(
                              wallet?.decimalPlaces || 2,
                            )}{' '}
                      {wallet?.currencyCode}
                    </IFText>
                  </div>
                </div>
              </div>
              <div className={Styles.ActionButton}>
                <IFButton
                  color={Colors.UserPagePrimary}
                  text={t('UserPage.Adjust')}
                  isLoading={false}
                  isDead={amount ? false : true}
                  onClick={() => {
                    setAmount()
                    setSign(t('UserPage.AdjustAmountButtonTextAdd'))
                    showDialogHandlerWallet.current.dismiss()
                    if (sign == t('UserPage.AdjustAmountButtonTextAdd')) {
                      adjustWallet(user.id, amount, wallet?.country)
                    } else {
                      adjustWallet(user.id, -amount, wallet?.country)
                    }
                  }}
                />
              </div>
            </div>
          </IFModal>
          <IFModal
            ref={showDialogHandlerPoints}
            dismissOnAccept={false}
            title={t('UserPage.PointsInfoModalTitle')}
            maxWidth="md"
            dialogContentStyle={{
              maxHeight: '480px',
              minHeight: 'auto',
            }}
            fullWidth={true}
            open={false}
          >
            <Scrollbars
              autoHide
              style={{ width: '100%', height: '100%' }}
              autoHeight
              autoHeightMin={0}
              autoHeightMax={480}
            >
              <PointsList userId={user.id} country={wallet?.country} />
            </Scrollbars>
          </IFModal>
        </div>
      )}
    </div>
  )
}
function mapDispatchToProps(dispatch) {
  return {
    fetchUserList: (paginationOffset, onError, onNotFound, shouldShowError) =>
      dispatch(
        UserActions.fetchUserList(
          paginationOffset,
          onError,
          onNotFound,
          shouldShowError,
        ),
      ),
    clearUsers: () => dispatch(UserActions.clearUsers()),
    setUsersFilter: (newFilter) =>
      dispatch(UserActions.setUsersFilter(newFilter)),
    adjustWallet: (id, amount, country) =>
      dispatch(UserActions.setCurrentUserNewBalance(id, amount, country)),
    toggleUserIsActive: (id, isActive) =>
      dispatch(UserActions.toggleCurrentUserIsActive(id, isActive)),
    fetchUserDetails: (userId, onNotFound) =>
      dispatch(UserActions.fetchUserDetails(userId, onNotFound)),
    fetchUserTransactionList: (userId, filter, offset, shouldShowError) =>
      dispatch(
        UserActions.fetchUserTransactionList(
          userId,
          filter,
          offset,
          shouldShowError,
        ),
      ),
    clearTransactions: () => dispatch(UserActions.clearTransactions()),
    setUserTransactionsFilter: (newFilter) =>
      dispatch(UserActions.setUserTransactionsFilter(newFilter)),
    clearCurrentUser: () => dispatch(UserActions.clearCurrentUser()),
    clearUserTransactionsFilter: (admin) =>
      dispatch(UserActions.clearUserTransactionsFilter(admin)),
    setCurrentUserNewPhone: (id, newPhone) =>
      dispatch(UserActions.setCurrentUserNewPhone(id, newPhone)),
    fetchUserPaymentSessionList: (userId, filter, offset, shouldShowError) =>
      dispatch(
        UserActions.fetchUserPaymentSessionList(
          userId,
          filter,
          offset,
          shouldShowError,
        ),
      ),
    clearPaymentSessions: () => dispatch(UserActions.clearPaymentSessions()),
    clearPoints: () => dispatch(UserActions.clearPoints()),
    setUserPaymentsFilter: (newFilter) =>
      dispatch(UserActions.setUserPaymentsFilter(newFilter)),
    clearUserPaymentsFilter: (admin) =>
      dispatch(UserActions.clearUserPaymentsFilter(admin)),
    setUserListSelectedIndex: (index) =>
      dispatch(UserActions.setUserListSelectedIndex(index)),
    setSelectedCountry: (newCountry) =>
      dispatch(UserActions.setSelectedCountry(newCountry)),
    fetchAdminActionsUsersList: (userId, filter, offset, shouldShowError) =>
      dispatch(
        UserActions.fetchAdminActionsUsersList(
          userId,
          filter,
          offset,
          shouldShowError,
        ),
      ),
    setAdminActionsFilter: (newFilter) =>
      dispatch(UserActions.setAdminActionsFilterUser(newFilter)),
    clearAdminActions: () => dispatch(UserActions.clearAdminActionsUser()),
    clearAdminActionsFilter: () =>
      dispatch(UserActions.clearAdminActionsFilterUser()),
    setAdminActionsPaginationOffset: (newOffset) =>
      dispatch(UserActions.setAdminActionsPaginationOffsetUser(newOffset)),
    setUserTransactionsPaginationOffset: (newOffset) =>
      dispatch(UserActions.setUserTransactionsPaginationOffset(newOffset)),
    setUserPaymentsPaginationOffset: (newOffset) =>
      dispatch(UserActions.setUserPaymentsPaginationOffset(newOffset)),
    fetchOngoingSessionsList: (userId) =>
      dispatch(UserActions.fetchOngoingSessionsList(userId)),
    setCurrentUserEmail: (id, email, isEmailVerified, onError) =>
      dispatch(
        UserActions.setCurrentUserEmail(id, email, isEmailVerified, onError),
      ),
    resendEmailVerification: (id) =>
      dispatch(UserActions.resendCurrentUserEmailVerification(id)),
    fetchUserNotificationList: (userId, filter, offset, shouldShowError) =>
      dispatch(
        UserActions.fetchUserNotificationList(
          userId,
          filter,
          offset,
          shouldShowError,
        ),
      ),
    setUserNotificationsFilter: (newFilter) =>
      dispatch(UserActions.setUserNotificationsFilter(newFilter)),
    clearNotifications: () => dispatch(UserActions.clearNotifications()),
    clearUserNotificationsFilter: (admin) =>
      dispatch(UserActions.clearUserNotificationsFilter(admin)),
    setUserNotificationsPaginationOffset: (newOffset) =>
      dispatch(UserActions.setUserNotificationsPaginationOffset(newOffset)),
  }
}

const mapStateToProps = (state) => ({
  transactionsFilter: UserSelectors.getTransactionsFilters(state),
  paymentsFilter: UserSelectors.getPaymentsFilters(state),
  usersFilter: UserSelectors.getUsersFilters(state),
  user: UserSelectors.getCurrentUser(state),
  fetchUserListRequestState: UserSelectors.getFetchUserListRequestState(state),
  userDetailsRequestState: UserSelectors.getUserDetailsRequestState(state),
  selectedUserId: UserSelectors.getSelectedUserId(state),
  admin: AuthSelectors.getUser(state),
  editingAdminRole: AuthSelectors.getEditingAdminRole(state),
  points: UserSelectors.getPointsList(state),
  usersCount: UserSelectors.getUsersCount(state),
  selectedUserIndex: UserSelectors.getSelectedUserIndex(state),
  userList: UserSelectors.getUserList(state),
  fetchUserTransactionListRequestState:
    UserSelectors.getFetchUserTransactionListRequestState(state),
  fetchPaymentSessionListRequestState:
    UserSelectors.getFetchUserPaymentSessionListRequestState(state),
  fetchUserListCountRequestState:
    UserSelectors.getFetchUserListCountRequestState(state),
  adminActions: UserSelectors.getAdminActionListUser(state),
  fetchAdminActionsRequestState:
    UserSelectors.getfetchAdminActionsRequestState(state),
  adminActionsPaginationOffset: UserSelectors.getAdminActionsListOffset(state),
  adminActionsFilters: UserSelectors.getAdminActionsFiltersUser(state),
  paymentSessionListPaginationOffset:
    UserSelectors.getPaymentSessionListPaginationOffset(state),
  transactionListPaginationOffset:
    UserSelectors.getTransactionListPaginationOffset(state),
  fetchOngoingSessionsListRequestState:
    UserSelectors.getFetchOngoingSessionsListRequestState(state),
  setCurrentUserEmailRequestState:
    UserSelectors.getSetCurrentUserEmailRequestState(state),
  resendEmailVerificationRequestState:
    UserSelectors.getResendEmailVerificationRequestState(state),
  notificationsFilters: UserSelectors.getNotificationsFilters(state),
  fetchUserNotificationListRequestState:
    UserSelectors.getFetchUserNotificationListRequestState(state),
})
export default connect(mapStateToProps, mapDispatchToProps)(UserPage)
